module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_4-99d207b846a73bed22e2514bd1f60785.png";